import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import userReducer from "../model/reducer";
import { uiReducer } from "../model/UiReducer";

const store = configureStore({
  reducer: {
    user: userReducer,
    ui: uiReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export default store;
